<template>
  <v-flex xs12 class="mb-4">
    <v-card outlined class="pa-4" style="border-radius: 8px; background-color: #F8F9FA;">
      <!-- Title -->
      <v-layout align-center class="mb-3">
        <v-icon color="#427D2D" class="mr-2">mdi-clock-fast</v-icon>
        <span style="font-family: poppinssemibold; font-size: 16px; color: #333;">
          Rescuer Response Analytics
        </span>
      </v-layout>

      <v-divider class="mb-3"></v-divider>

      <!-- Grid of Duration Chips -->
      <v-layout wrap>
        
        <!-- 1. Sighting Reported (Always visible in all 4 pages) -->
        <v-flex xs12 sm6 md3 class="pa-2">
          <div class="caption text-muted">Case Reported Date and Time</div>
          <strong style="font-size: 13px;">{{ formatTime(data.reportedAt) }}</strong>
        </v-flex>

        <!-- 2. Time Taken to Accept (Visible in Assigned, Rescued, and Released) -->
        <v-flex 
          xs12 sm6 md3 class="pa-2"
          v-if="['Assigned', 'Rescued', 'Released', 'Approved', 'Closed'].includes(data.status)"
        >
          <div class="caption text-muted">Time taken to Accept the case</div>
          <v-chip small color="orange lighten-4" text-color="orange darken-4" class="font-weight-bold">
            {{ getDuration(data.reportedAt, data.assignedAt) }}
          </v-chip>
        </v-flex>

        <!-- 3. Time Taken to Reach (Visible in Assigned, Rescued, and Released) -->
        <v-flex 
          xs12 sm6 md3 class="pa-2"
          v-if="['Assigned', 'Rescued', 'Released', 'Approved', 'Closed'].includes(data.status)"
        >
          <div class="caption text-muted">Time taken to reach Location</div>
          <v-chip 
            small 
            :color="data.reachedAt ? 'purple lighten-4' : 'grey lighten-3'" 
            :text-color="data.reachedAt ? 'purple darken-4' : 'grey darken-6'" 
            class="font-weight-bold"
          >
            {{ data.reachedAt ? getDuration(data.assignedAt, data.reachedAt) : 'En Route / Traveling' }}
          </v-chip>
        </v-flex>

        <!-- 4. Time Taken to Capture (Visible in Rescued and Released) -->
        <v-flex 
          xs12 sm6 md3 class="pa-2"
          v-if="['Rescued', 'Released', 'Approved', 'Closed'].includes(data.status)"
        >
          <div class="caption text-muted">Time taken for Rescue</div>
          <v-chip small color="green lighten-4" text-color="green darken-4" class="font-weight-bold">
            {{ getDuration(data.reachedAt, data.rescue ? data.rescue.rescuedAt : null) }}
          </v-chip>
        </v-flex>

        <!-- 5. Time Taken to Release (Visible only in Released) -->
        <v-flex 
          xs12 sm6 md3 class="pa-2"
          v-if="['Released', 'Approved', 'Closed'].includes(data.status) && data.release"
        >
          <div class="caption text-muted">Time taken to Release after rescue</div>
          <v-chip small color="teal lighten-4" text-color="teal darken-4" class="font-weight-bold">
            {{ getDuration(data.rescue ? data.rescue.rescuedAt : null, data.release ? data.release.releasedAt : null) }}
          </v-chip>
        </v-flex>

      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: ["data"],
  methods: {
    formatTime(date) {
      if (!date) return "N/A";
      const options = { hour: '2-digit', minute: '2-digit', day: '2-digit', month: 'short' };
      return new Date(date).toLocaleDateString('en-US', options);
    },
    getDuration(startDate, endDate) {
      if (!startDate || !endDate) return "N/A";
      
      const diffMs = Math.abs(new Date(endDate) - new Date(startDate));
      const diffSecs = Math.floor(diffMs / 1000);
      
      // 1. Seconds format
      if (diffSecs < 60) {
        return `${diffSecs} ${diffSecs === 1 ? 'sec' : 'secs'}`;
      }
      
      // 2. Minutes format
      const diffMins = Math.floor(diffSecs / 60);
      if (diffMins < 60) {
        return `${diffMins} ${diffMins === 1 ? 'min' : 'mins'}`;
      }
      
      // 3. Hours and Minutes format
      const diffHrs = Math.floor(diffMins / 60);
      const remainingMins = diffMins % 60;
      if (diffHrs < 24) {
        if (remainingMins === 0) {
          return `${diffHrs} ${diffHrs === 1 ? 'hr' : 'hrs'}`;
        }
        return `${diffHrs} ${diffHrs === 1 ? 'hr' : 'hrs'} ${remainingMins} ${remainingMins === 1 ? 'min' : 'mins'}`;
      }
      
      // 4. Days and Hours format
      const diffDays = Math.floor(diffHrs / 24);
      const remainingHrs = diffHrs % 24;
      if (diffDays < 30) {
        if (remainingHrs === 0) {
          return `${diffDays} ${diffDays === 1 ? 'day' : 'days'}`;
        }
        return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ${remainingHrs} ${remainingHrs === 1 ? 'hr' : 'hrs'}`;
      }
      
      // 5. Months and Days format
      const diffMonths = Math.floor(diffDays / 30);
      const remainingDays = diffDays % 30;
      if (remainingDays === 0) {
        return `${diffMonths} ${diffMonths === 1 ? 'month' : 'months'}`;
      }
      return `${diffMonths} ${diffMonths === 1 ? 'month' : 'months'} ${remainingDays} ${remainingDays === 1 ? 'day' : 'days'}`;
    }
  }
};
</script>
